import { getBreakpoint } from "../localStorage.js";

export const USER_SETTING_KEYS = {
  rowGroupPanelShow: "rowGroupPanelShow",
  floatingFilterShow: "floatingFilterShow",
  pagination: "pagination",
  lastTopVisibleRowIndex: "lastTopVisibleRowIndex",
  lastVisitedPage: "lastVisitedPage",
  filterModel: "filterModel",
  columnState: "columnState",
  allowBulkUpdate: "allowBulkUpdate",
  breakpoint: "breakpoint",
  hiddenFields: "hiddenFields",
};

export const defaultUserSettings = {
  [USER_SETTING_KEYS.rowGroupPanelShow]: false,
  [USER_SETTING_KEYS.floatingFilterShow]: true,
  [USER_SETTING_KEYS.pagination]: true,
  [USER_SETTING_KEYS.lastTopVisibleRowIndex]: 0,
  [USER_SETTING_KEYS.lastVisitedPage]: 0,
  [USER_SETTING_KEYS.filterModel]: {},
  [USER_SETTING_KEYS.columnState]: [],
  [USER_SETTING_KEYS.allowBulkUpdate]: false,
  [USER_SETTING_KEYS.breakpoint]: getBreakpoint(),
  [USER_SETTING_KEYS.hiddenFields]: [],
};
